module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visionStyle"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc"
    }
  }, [_c('li', [_vm._v("Since "), _c('scanBold', [_vm._v("Co-Founding")]), _vm._v(" an "), _c('scanBold', [_vm._v("Educational-Tech R&D Center")]), _vm._v(" -- "), _c('a', {
    staticClass: "urlLink",
    staticStyle: {
      "color": "blue",
      "text-decoration-line": "underline",
      "font-size": "100%"
    },
    attrs: {
      "href": "http://www.eande.world/",
      "target": "_blank"
    }
  }, [_vm._v("Encourage and Empower (EandE)")]), _vm._v(" -- in 2004 at my home/garage, I've enjoyed serving as "), _c('scanBold', [_vm._v("Sr. Instructor and Curriculum-Engineer")]), _vm._v(" where we developed "), _c('scanBold', [_vm._v("\"T.A.C.H.nology® Robotics w/ Arduino & Raspberry Pi\"")]), _vm._v(" as Silicon Valley's 1st Open-Source, Competition-Grade & Lower-Cost Alternative to LEGO®, TETRIX® & VEX® Robotics.")], 1), _vm._v(" "), _c('li', [_c('scanBold', [_vm._v("Innovations")]), _vm._v(" behind our Educational Robotics System include (more details, photos and short videos can be found at "), _c('a', {
    staticClass: "urlLink",
    staticStyle: {
      "color": "blue",
      "text-decoration-line": "underline",
      "font-size": "100%"
    },
    attrs: {
      "href": "http://www.eande.world/",
      "target": "_blank"
    }
  }, [_vm._v("EandE")]), _vm._v("):\n      "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Creative S.T.E.A.M.-Based Hardware-Chassis that integrates \"T.echnology, A.rts & C.rafts... H.olistically\" to inspire Industry-Grade Robotics to both Primary & Secondary School students, as showcased at "), _c('scanBold', [_vm._v("San Jose's Tech Museum and Bay Area's Maker Faire Premier Showroom")]), _vm._v(" (campus attracted 100k+ spectators),")], 1), _vm._v(" "), _c('li', [_vm._v("Industry-Leading Cloud-Based Raspberry-Pi Remote-Control System (Python & C++) that helped lead to a "), _c('scanBold', [_vm._v("1-year alliance with Siemens-eMeter in Foster City")]), _vm._v(" to collaborate on Web Full-Stack Technologies (JavaScript & Python) for their Cloud-Based Energy Smart-Grids, and")], 1), _vm._v(" "), _c('li', [_vm._v("Award-Winning Google-Based 'Blockly Drag-n-Drop' C++ Coding Editor (JavaScript & Python) that opened an opportunity to serve as "), _c('scanBold', [_vm._v("Adjunct Professor for CS110 'C 'Programming at Cogswell Polytechnical College in San Jose")]), _vm._v(".")], 1)])], 1), _vm._v(" "), _c('li', [_vm._v("These above experiences have inspired my R&D efforts at EandE to form the following "), _c('scanBold', [_vm._v("Vision to Encourage and Empower")]), _vm._v(" our students regarding the "), _c('scanBold', [_vm._v("#1 Hi-Tech Career Path… Web/Cloud Development "), _c('scanSlideRef', [_vm._v("(refer below to Slide #1)")])], 1), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc"
    }
  }, [_c('li', [_vm._v("As "), _c('scanBold', [_vm._v("Open-Source Web/Cloud Technologies")]), _vm._v(" mature and become more mainstreamed into industry, students in Computer Science  -- especially for Colleges and Secondary Schools with limited resources -- are more freed from the previous struggle of playing 'catch-up' to a once 'closed-source, limited-access & high-cost' Hi-Tech field of the past.")], 1), _vm._v(" "), _c('li', [_vm._v("And by properly harnessing this global "), _c('scanBold', [_vm._v("Open-Source Revolution")]), _vm._v(", students can 1) be empowered to innovate with the 'best-of-the-best' world-wide -- regardless of age or socio-economic background -- and subsequently 2) be encouraged to give back to society through "), _c('scanBold', [_vm._v("Open-Source Collaboration")]), _vm._v(".")], 1), _vm._v(" "), _c('li', [_vm._v("Thus our students do not passively-settle as 'industry-learners' -- but rather -- actively-contribute as 'industry-innovators' in responsibly building a stronger community... for life.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("Traditionally, I've enjoyed coding and teaching "), _c('scanBold', [_vm._v("Java, C#, C++ & C")]), _vm._v(" -- among many other Linux-Based languages/toolsets.")], 1), _vm._v(" "), _c('li', [_vm._v("Yet due to the global pervasiveness of Web/Cloud-Services and Robotics, Stack Overflow's 2018 Global Survey of 100K Developers concludes that two Open-Source Languages -- "), _c('scanBold', [_vm._v("JavaScript")]), _vm._v(" and "), _c('scanBold', [_vm._v("Python")]), _vm._v(" -- have taken our world by 'storm', at least for these past several years "), _c('scanSlideRef', [_vm._v("(Slide #2)")]), _vm._v(".")], 1), _vm._v(" "), _c('li', [_vm._v("Thus from our "), _c('a', {
    staticClass: "urlLink",
    staticStyle: {
      "color": "blue",
      "text-decoration-line": "underline",
      "font-size": "100%"
    },
    attrs: {
      "href": "http://www.eande.world/",
      "target": "_blank"
    }
  }, [_vm._v("Encourage and Empower's (EandE) Instructional R&D Lab")]), _vm._v("  (as based at my home/garage since 2004), I wish to present this "), _c('scanBold', [_vm._v("Online Portfolio")]), _vm._v(" of "), _c('scanBold', [_vm._v("JavaScript & Python Curriculum-Based Projects")]), _vm._v(" to spark our "), _c('scanBold', [_vm._v("Student's Innovation")]), _vm._v(" within the "), _c('scanBold', [_vm._v("Open-Source Global-Ecosystem")]), _vm._v(".")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("And with regards to the "), _c('scanBold', [_vm._v("Most Popular Ecosystem: JavaScript")]), _vm._v(" "), _c('scanSlideRef', [_vm._v("(Slide #2)")]), _vm._v(", the following Web/Cloud Technologies are showcased:\n      "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Front-end: "), _c('scanBold', [_vm._v("React")]), _vm._v(" and "), _c('scanBold', [_vm._v("Vue.js")]), _vm._v(" as Top 2 Frameworks in Popularity "), _c('scanSlideRef', [_vm._v("(Slides #3, #4 & #5).")])], 1), _vm._v(" "), _c('li', [_vm._v("Back-end: "), _c('scanBold', [_vm._v("Node.js")]), _vm._v(" as Industry's #1 De Facto Standard "), _c('scanSlideRef', [_vm._v("(Slide #6)")]), _vm._v(".")], 1)])], 1)]), _vm._v(" "), _c('h1', [_vm._v("World-Wide Software Development Trends:")]), _vm._v(" "), _c('carousel', {
    attrs: {
      "perPage": 1,
      "autoplay": true,
      "autoplayTimeout": 5000,
      "loop": true,
      "navigationEnabled": true,
      "mouseDrag": false,
      "paginationActiveColor": "#42b983",
      "paginationColor": "#b2ebd1",
      "paginationSize": "20",
      "paginationPadding": "10",
      "easing": "ease",
      "speed": "1000"
    }
  }, [_c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #1")]), _c('br'), _vm._v("Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,"), _c('br'), _vm._v("Top 3 Developer-Types Share Only One Common Language: JavaScript")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://insights.stackoverflow.com/survey/2018#developer-roles",
      "target": "_blank"
    }
  }, [_vm._v("[https://insights.stackoverflow.com/survey/2018#developer-roles]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/Stackoverflow-DeveloperType-Survey.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #2")]), _c('br'), _vm._v("Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,"), _c('br'), _vm._v("JavaScript, CSS, HTML (All Web-Based Tools) are Top 3 in Popularity")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://insights.stackoverflow.com/survey/2018#most-popular-technologies",
      "target": "_blank"
    }
  }, [_vm._v("[https://insights.stackoverflow.com/survey/2018#most-popular-technologies]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/Stackoverflow-MostPopularTech-JavaScript.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #3")]), _c('br'), _vm._v("Based on GitHub's 3-Year Star-Ratings of Top 3 JS Frameworks,"), _c('br'), _vm._v("Vue.js #1 in Greatest Momentum (React #2)")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "http://www.timqian.com/star-history/#facebook/react&angular/angular&vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("[http://www.timqian.com/star-history/#facebook/react&angular/angular&vuejs/vue]")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://bestof.js.org/tags/framework/trending/last-12-months",
      "target": "_blank"
    }
  }, [_vm._v("[https://bestof.js.org/tags/framework/trending/last-12-months]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/BestOfJsDotOrg-UiFramework-GithubStars.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #4")]), _c('br'), _vm._v("Based on Worldwide 2017 Poll of 28,000 JS Developers,"), _c('br'), _vm._v("Vue.js #1 in Potential Market for Training (React #2)")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://stateofjs.com/2017/front-end/results/",
      "target": "_blank"
    }
  }, [_vm._v("[https://stateofjs.com/2017/front-end/results/]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/VueVsReact-StateOfJsDotCom.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #5")]), _c('br'), _vm._v("Based on GitHub's 2017 Star-Ratings of All JS Projects,"), _c('br'), _vm._v("Vue.js #1 in Popularity (React #2)")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://risingstars.js.org/2017/en/#section-all",
      "target": "_blank"
    }
  }, [_vm._v("[https://risingstars.js.org/2017/en/#section-all]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/VueVsReact-RisingStarsDotJsDotOrg.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #6")]), _c('br'), _vm._v("Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,"), _c('br'), _vm._v("Node.js #1 in Framework Popularity")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://insights.stackoverflow.com/survey/2018#technology-frameworks-libraries-and-tools",
      "target": "_blank"
    }
  }, [_vm._v("[https://insights.stackoverflow.com/survey/2018#technology-frameworks-libraries-and-tools]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/Stackoverflow-Framework-Node-Survey.png"
    }
  })])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("A Vision for Silicon Valley's First "), _c('br'), _vm._v("Open-Source, Competition-Grade & Lower-Cost Robotics System...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("...Inspires a Progressive Vision for"), _c('br'), _vm._v("Students as 'Web/Cloud-Innovators' through Computer Science")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b892667"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vision.vue
// module id = 116
// module chunks = 1